import autobind from 'core-decorators/lib/autobind';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import requestLoginModes from 'shared/constants/request-login-modes';

import { WixConnect } from 'shared/utils/wix-connect';
import WixSDK from 'shared/utils/wix-sdk';

import { LinkButton } from 'shared/components/button/button';
import Button from 'widget/components/button/button';

import { PAYMENT_TYPE } from 'shared/constants/payments';

import styles from './account-form.styl';

import translations from './translations';


@connect(state => ({
  currentSiteUser: state.currentSiteUser,
}))
@WixConnect(styles)
export default class AccountForm extends React.Component {

  static propTypes = {
    proceedText: React.PropTypes.any,
    proceedAction: React.PropTypes.func,
    biEvent: React.PropTypes.func,
    currentSiteUser: React.PropTypes.object,
    onUserLogin: React.PropTypes.func,
    onUserLogout: React.PropTypes.func,
    paymentType: React.PropTypes.oneOf([
      PAYMENT_TYPE.SUBSCRIPTION,
      PAYMENT_TYPE.PURCHASE,
      PAYMENT_TYPE.RENT,
      PAYMENT_TYPE.MEMBER_ONLY,
    ]),
  };

  static defaultProps = {
    proceedAction: _.noop,
    onUserLogin: _.noop,
    onUserLogout: _.noop,
    centered: false,
  };

  get activity() {
    const { currentSiteUser, paymentType } = this.props;

    if (paymentType === PAYMENT_TYPE.MEMBER_ONLY) {
      return this.memberOnlyActivity;
    }

    if (currentSiteUser) {
      return this.signedActivity;
    }

    return this.signInActivity;
  }

  get memberOnlyActivity() {
    return (
      <div styleName="content-wrapper">
        <header styleName="header">
          <div>
            <FormattedMessage {...translations.signInToWatch1} />
          </div>
          <div>
            <FormattedMessage {...translations.signInToWatch2} />
          </div>
        </header>

        <Button styleName="sign-up-button"
                className="qa-widget-payment-signup-button"
                onClick={this.clickSignUpButtonHandler}
                disableTheme>
          <FormattedMessage {...translations.signUp} />
        </Button>
      </div>
    );
  }

  get signInActivity() {
    return (
      <div styleName="content-wrapper">
        <header styleName="header">
          <div>
            <FormattedMessage {...translations.signInToComplete1} />
          </div>
          <div>
            <FormattedMessage {...translations.signInToComplete2} />
          </div>
        </header>

        <Button styleName="sign-up-button"
                className="qa-widget-payment-signup-button"
                onClick={this.clickSignUpButtonHandler}
                disableTheme>
          <FormattedMessage {...translations.signUp} />
        </Button>

        <div styleName="sign-in-wrapper">
          <FormattedMessage {...translations.haveAccount} />
          {' '}
          <LinkButton onClick={this.clickSignInButtonHandler}
                      styleName="sign-in-button">
            <FormattedMessage {...translations.signIn} />
          </LinkButton>
        </div>
      </div>
    );
  }

  @autobind
  clickSignUpButtonHandler() {
    const { biEvent, onUserLogin } = this.props;

    biEvent('widget.signup.clicked');
    WixSDK.requestLogin()
      .then(onUserLogin);
  }

  @autobind
  clickSignInButtonHandler() {
    const { onUserLogin } = this.props;

    WixSDK.requestLogin({
      mode: requestLoginModes.LOGIN,
    })
      .then(onUserLogin);
  }

  @autobind
  clickLogOutButtonHandler() {
    WixSDK.logOutCurrentMember();
    this.props.onUserLogout();
  }

  get signedActivity() {
    const { currentSiteUser } = this.props;

    return (
      <div styleName="content-wrapper">
        <header styleName="header">
          <FormattedMessage {...translations.readyAction} />
        </header>

        <div styleName="signed-message">
          <FormattedMessage {...translations.signedAs} />
        </div>
        <div>
          {currentSiteUser.email}
        </div>
        <div styleName="signed-message">
          <FormattedMessage {...translations.notYourAccount} />
          {' '}
          <LinkButton onClick={this.clickLogOutButtonHandler}
                      styleName="logout-button">
            <FormattedMessage {...translations.logout} />
          </LinkButton>
        </div>
      </div>
    );
  }

  get proceedButton() {
    const { currentSiteUser, proceedText, proceedAction } = this.props;

    if (!currentSiteUser || !proceedText) {
      return null;
    }

    return (
      <Button styleName="proceed-button"
              onClick={proceedAction}
              disableTheme>
        {proceedText}
      </Button>
    );
  }

  render() {
    return (
      <section styleName="wrapper">
        {this.activity}
        {this.proceedButton}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-form.js